<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>在线数据</span>
        </div>
        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="类型" prop="type">
            <el-select v-model="queryParams.type" size="mini" placeholder="请选择">
              <el-option
                v-for="item in types"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              size="mini"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
          </el-form-item>
        </el-form>
        <div ref="chartContainer" style="width: 100%; height: 400px;" />

      </el-card>
      <el-card v-if="showTable" class="box-card">
        <el-table :data="date" border stripe>
          <el-table-column prop="start" label="时间">
            <template slot-scope="scope">
              <span>{{ scope.row }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="start" label="北京时间">
            <template slot-scope="scope">
              <span>{{ bjdate[scope.$index] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="今日">
            <template slot-scope="scope">
              <span>{{ today[scope.$index] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="昨日">
            <template slot-scope="scope">
              <span>{{ yesterday[scope.$index] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserOnline } from '@/api/statistics/user_remain'
import echarts from 'echarts'
import { getLastDates } from '@/utils'

export default {
  name: 'UserOnline',
  props: {
    showTable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      types: [
        { label: '小时', value: 1 },
        { label: '1分钟', value: 4 },
        { label: '10分钟', value: 2 },
        { label: '30分钟', value: 3 }
      ],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        type: 2,
        yesterday: 1
      },
      loading: false,
      options: [],
      tableData: [],
      date: [],
      bjdate: [],
      today: [],
      yesterday: []
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getTables()
    })
  },
  methods: {
    handleKeyUp() {
      this.onSubmit()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      this.getTables()
    },
    getTables() {
      const chart = echarts.init(this.$refs.chartContainer)
      chart.showLoading()
      const option = {
        title: {
          text: '在线数据'
        },
        xAxis: [{
          name: '时间',
          type: 'category',
          data: []
        }, {
          type: 'category',
          data: [],
          axisLabel: {
            show: true
          },
          axisLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          },
          position: 'bottom',
          offset: 25
        }],
        legend: {
          data: ['今日', '昨日'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '今日',
            data: [],
            type: 'line',
            smooth: true,
            xAxisIndex: 0,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            },
            itemStyle: {
              normal: {
                color: 'red' // 改变线条颜色
              }
            }
          },
          {
            name: '昨日',
            xAxisIndex: 0,
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            },
            itemStyle: {
              normal: {
                color: '#00BFFF' // 改变线条颜色
              }
            }
          }
        ]
      }
      this.loading = true
      getUserOnline(this.queryParams).then(res => {
        this.loading = false
        chart.hideLoading()
        if (res.code === 200) {
          this.date = res.data.hour
          this.bjdate = res.data.bjHour
          this.today = res.data.online
          this.yesterday = res.data.yOnline
          option.xAxis[0].data = this.date
          option.xAxis[1].data = res.data.bjHour
          option.series[0].data = this.today
          option.series[1].data = this.yesterday
          this.queryParams.startDate = res.data.req.startDate

          // console.log('option', option)
          chart.setOption(option)
        } else {
          this.msgError(res.msg)
        }
      })
    },

    numFormatter(row, column, cellValue, index) {
      return cellValue + '%'
    }
  }
}
</script>

<style scoped>
</style>
